exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blockSteps {\n  pointer-events: none; }\n\n.nav_download_btn {\n  float: right;\n  margin-top: -45px;\n  margin-right: 15px; }\n  @media only screen and (min-width: 768px) and (max-width: 1440px) {\n    .nav_download_btn {\n      margin-top: -37px; } }\n  @media only screen and (max-width: 767px) {\n    .nav_download_btn {\n      margin: 10px;\n      float: none;\n      text-align: center; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create/universe_lite/Analyze/analysis/navigation/nav.style.scss
// module id = 863
// module chunks = 0